/**
 * @description 保費試算結果 body 區塊使用
*/
export enum EvalInfoBodyType {
  ROW='ROW',
  FOLDABLE = 'FOLDABLE'
}
